import { gsap } from 'gsap'
import { deepMerge } from 'js/utils/Utils'
import { roundEx } from 'js/utils/Maths'

import Common from 'js/_core/Common'

const defaults = {
  instanceName: 'companyMarqueeSlideshow',
  $names: {
    wrap: '[data-marquee-wrap="company-first"]',
    list: '[data-marquee-list="company-first"]',
    item: '[data-marquee-list-item="company-first"]',
    thumb: '[data-marquee-thumb="company-first"]',
  },
  speed: 0.5,
}

export default class CompanyMarqueeSlideshow {
  $contentRoot = document.body

  $wrap = null
  $list = null
  $itemOrigin = null
  $thumbs = null
  $items = []
  slideShowInfo = []
  thumbGroupSize = 0

  currentThumbIndex = 0

  itemWidth = 0
  positionX = 0

  constructor(options = {}) {
    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
    this.createClone()
    this._setInfo()
    this._setSize()
    this._addHandlers()

    gsap.delayedCall(5, () => {
      this.autoPlay()
    })
  }

  destroy() {
    this._removeHandlers()
  }

  _set$() {
    this.$wrap = this.$contentRoot.querySelector(this.$names.wrap)
    this.$list = this.$contentRoot.querySelector(this.$names.list)
    this.$itemOrigin = this.$contentRoot.querySelector(this.$names.item)
    this.$thumbs = this.$contentRoot.querySelectorAll(this.$names.thumb)
  }

  createClone() {
    if (!this.$list) return

    this.thumbGroupSize = this.$thumbs.length

    for (let i = 0; i < 4; i++) {
      const $cloneItem = this.$itemOrigin.cloneNode(true)
      this.$list.appendChild($cloneItem)
    }

    this.$items = this.$list.querySelectorAll(this.$names.item)
  }

  _setInfo() {
    for (let i = 0; i < this.thumbGroupSize; i++) {
      this.slideShowInfo[i] = {
        $thumbs: [],
      }

      this.$items.forEach(($item, j) => {
        const $thumbs = $item.querySelectorAll(this.$names.thumb)
        $thumbs.forEach(($thumb, k) => {
          if (k === i) {
            this.slideShowInfo[i].$thumbs.push($thumb)
          }
        })
      })
    }
  }

  _addHandlers() {
    if (Common.raf) {
      Common.raf.addHandler(() => {
        this.onRaf()
      }, this.instanceName)
    }

    if (Common.resize) {
      Common.resize.addHandler(() => {
        this.onResize()
      }, this.instanceName)
    }
  }

  _removeHandlers() {
    if (Common.raf) {
      Common.raf.removeHandler(this.instanceName)
    }

    if (Common.resize) {
      Common.resize.removeHandler(this.instanceName)
    }
  }

  autoPlay() {
    this.toNextThumb()
    gsap.delayedCall(5, () => {
      this.autoPlay()
    })
  }

  toNextThumb() {
    this.currentThumbIndex = (this.currentThumbIndex + 1) % this.thumbGroupSize

    this.slideShowInfo.forEach((info, i) => {
      info.$thumbs.forEach(($thumb, j) => {
        if (i === this.currentThumbIndex) {
          gsap.killTweensOf($thumb)
          gsap.to($thumb, {
            opacity: 1,
            duration: 0.5,
            delay: j * 0.075,
            ease: 'none',
          })
        } else {
          gsap.killTweensOf($thumb)
          gsap.to($thumb, {
            opacity: 0,
            duration: 0.5,
            delay: j * 0.075,
            ease: 'none',
          })
        }
      })
    })
  }

  _setSize() {
    this.itemWidth = this.$itemOrigin.getBoundingClientRect().width || 0
  }

  _setMarqueePosition() {
    if (!this.$list) return

    this.positionX -= this.speed
    this.positionX %= this.itemWidth

    this.positionX = roundEx(this.positionX, 10000)

    this.$list.style.transform = `translate3d(${this.positionX}px, 0, 0) rotate(0.0001deg)`
  }

  onRaf() {
    this._setMarqueePosition()
  }

  onResize() {
    this._setSize()
  }
}